import React from 'react';

const baseImgUrl = 'https://static.lenskart.com/media/owndays/img/brands';
const baseImgUrl2 = 'https://static.lenskart.com/owndays/img/brands';
const baseNewImgUrl = 'https://static.lenskart.com/owndays/img/news';
const baseCanonicalUrl = 'https://www.owndays.com/sg/en/eyeglasses/brands';
const baseNewOgImgUrl = 'https://static1.lenskart.com/owndays/img/brands';

export const BRANDS = [
  {
    metaTitle: 'TOY STORY | OWNDAYS',
    title: (
      <>
        <span>Do you remember your first toy? </span>
        <span>What about your favourite one? </span>
      </>
    ),
    targetPath: '/eyeglasses/brands/toystory.html',
    detectProductDetailPath: 'toystory',
    logo: `${baseImgUrl2}/toystory/brand_logo.webp`,
    bgPc: `${baseImgUrl2}/toystory/bg-pc.webp`,
    bgSp: `${baseImgUrl2}/toystory/bg-sp.webp`,
    ogImage: `${baseImgUrl2}/toystory/ogp_1200x630.webp`,
    description:
      'Step into the TOY STORY | OWNDAYS eyewear collection where imagination and childhood joy come to life once again. Inspired by the beloved Disney Pixar Toy Story characters, the collection features 12 models, each capturing the unique charm of Woody, Buzz Lightyear, Jessie, Rex, Bo Peep and more!',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/toystory.html`,
  },
  {
    metaTitle: 'OWNDAYS | ESSENTIAL',
    title: (
      <>
        <span>The New Norm</span>
        <span>Finding Joy In Your Eyewear</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/essential.html',
    detectProductDetailPath: 'essential',
    logo: `${baseImgUrl}/essential/logo.webp`,
    bgPc: `${baseImgUrl}/essential/bg-pc.webp`,
    bgSp: `${baseImgUrl}/essential/bg-sp.webp`,
    ogImage: `${baseImgUrl}/essential/ogp_1200x630.webp`,
    description:
      'A collection that is impeccably tasteful, featuring frames in sleek silhouettes with delicate accents.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/essential.html`,
  },
  {
    metaTitle: 'OWNDAYS | SUN',
    title: (
      <>
        <span>The day is yours!</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/sun.html',
    detectProductDetailPath: 'sun',
    logo: `${baseImgUrl}/sun/logo.webp`,
    bgPc: `${baseImgUrl2}/sun/bg-pc.webp`,
    bgSp: `${baseImgUrl2}/sun/bg-sp.webp`,
    ogImage: `${baseImgUrl}/sun/ogp_1200x630.webp`,
    description:
      'Where fashion meets function. Coming in an array of vibrant designs, these sunglasses not only reduce glare and protect your eyes from UV rays but also enable you to see the world more vividly. With SUN by your side, every moment becomes extra special. ',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/sun.html`,
  },
  {
    metaTitle: 'OWNDAYS | AIR',
    title: (
      <>
        <span>Incredibly Lightweight</span>
        <span>The Durability You Can Rely On</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/air.html',
    detectProductDetailPath: 'air',
    logo: `${baseImgUrl}/air/logo.webp`,
    bgPc: `${baseImgUrl}/air/bg-pc.webp`,
    bgSp: `${baseImgUrl}/air/bg-sp.webp`,
    ogImage: `${baseImgUrl}/air/ogp_1200x630.webp`,
    description:
      'Engineered with ultra-lightweight and highly durable materials to deliver a wearing comfort that feels like air, these metal frames offer an impeccable fit and can be worn comfortably for long hours.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/air.html`,
  },
  {
    metaTitle: 'ZEON × OWNDAYS',
    title: null,
    targetPath: '/eyeglasses/brands/zeon.html',
    detectProductDetailPath: 'gundam',
    logo: `${baseImgUrl}/gundam5-zeon-new/logo.webp`,
    bgPc: `${baseImgUrl}/gundam5-zeon-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/gundam5-zeon-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/gundam5-zeon-new/ogp_1200x630.webp`,
    description:
      'From Mobile Suit Gundam, one of the most iconic Japanese anime series that has remained highly popular across generations, comes an eyewear collaboration focusing on the Principality of Zeon. The lineup consists of a spectacle model and a sunglass model.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/zeon.html`,
  },
  {
    metaTitle: 'Graph Belle',
    title: (
      <>
        <span>The Definition Of Me</span>
        <span>Composed And Elegant</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/graphbelle.html',
    detectProductDetailPath: 'graph-belle',
    logo: `${baseImgUrl}/graphbelle-new/logo.webp`,
    bgPc: `${baseImgUrl}/graphbelle-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/graphbelle-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/graphbelle-new/ogp_1200x630.webp`,
    description:
      'A collection that is impeccably tasteful, featuring frames in sleek silhouettes with delicate accents.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/graphbelle.html`,
  },
  {
    metaTitle: 'Junni',
    title: (
      <>
        <span>Levelling Up To The Adults</span>
        <span>In Style And Durability</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/Junni.html',
    detectProductDetailPath: 'junni',
    logo: `${baseImgUrl}/junni-new/logo.webp`,
    bgPc: `${baseImgUrl}/junni-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/junni-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/junni-new/ogp_1200x630.webp`,
    description:
      'A delightful frame collection designed specifically for children, drawing on the concept of “fashion is not just for the adults”. Pairing stylish designs with an emphasis on comfort and impeccable fitting, they are perfect for everyday use by the little ones.',
    isDarkTheme: true,
    canonicalUrl: `${baseCanonicalUrl}/Junni.html`,
  },
  {
    metaTitle: 'Harry Potter × OWNDAYS',
    title1: null,
    targetPath: '/eyeglasses/brands/harry-potter.html',
    detectProductDetailPath: 'harry-potter',
    logo: `${baseImgUrl}/harry-potter-new/logo.webp`,
    bgPc: `${baseImgUrl}/harry-potter-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/harry-potter-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/harry-potter/ogp_1200x630.webp`,
    description:
      'Embark on an enchanting journey with the Harry Potter × OWNDAYS frame collection. Consisting of 6 models in an assortment of metal and plastic materials, the limited-edition collection is a tribute to the beloved film series.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/harry-potter.html`,
  },
  {
    metaTitle: 'John Dillinger',
    title: (
      <>
        <span>Vintage</span>
        <span>Reinterpreted</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/JohnDillinger.html',
    detectProductDetailPath: 'john-dillinger',
    logo: `${baseImgUrl}/johndillinger-new/logo.webp`,
    bgPc: `${baseImgUrl}/johndillinger-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/johndillinger-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/johndillinger/ogp_1200x630.webp`,
    description:
      'This frame collection depicts a contemporary revival of retro styles, meticulously weaving intricate details such as colours, patterns and metallic accents with evolving perspectives.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/JohnDillinger.html`,
  },
  {
    metaTitle: 'Senichisaku',
    title: (
      <>
        <span>Japanese Craftsmanship</span>
        <span>The Epitome Of Sublime Beauty</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/Senichisaku.html',
    detectProductDetailPath: 'senichisaku',
    logo: `${baseImgUrl}/senichi-new/logo.webp`,
    bgPc: `${baseImgUrl}/senichi-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/senichi-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/senichi/ogp_1200x630.webp`,
    description:
      'Sabae, a city located in Fukui Prefecture, Japan, is widely regarded as the City of Eyewear. This is where Senichisaku frames are crafted, with every pair carefully put together by hand.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/Senichisaku.html`,
  },
  {
    metaTitle: 'OWNDAYS PC',
    title: (
      <>
        <span>The Smart Choice</span>
        <span>For Digital-Age Consumers</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/owndayspc.html',
    detectProductDetailPath: 'pc',
    logo: `${baseImgUrl}/owndays-pc-new/logo.webp`,
    bgPc: `${baseImgUrl}/owndays-pc-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/owndays-pc-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/owndays-pc-new/ogp_1200x630.webp`,
    description:
      'Designed for digital-age consumers who often spend long hours on computers, TVs, smartphones and gaming devices, OWNDAYS PC eases eyestrain and offers a more comfortable visual experience by reducing screen brightness and glare.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/owndayspc.html`,
  },
  {
    metaTitle: 'K.Moriyama',
    title: (
      <>
        <span>Creating Fluid Strokes</span>
        <span>Always Radiating In Elegance</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/kmoriyama.html',
    detectProductDetailPath: 'k.moriyama',
    logo: `${baseImgUrl}/kmoriyama-new/logo.webp`,
    bgPc: `${baseImgUrl}/kmoriyama-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/kmoriyama-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/kmoriyama/ogp_1200x630.webp`,
    description:
      'A collection of metal frames synonymous with sophistication and elegance. The use of metallic components is an intentional approach to create a lustrous shine that bounces off the frame with every movement and change in lighting. ',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/Kmoriyama.html`,
  },
  {
    metaTitle: 'Niche',
    title: (
      <>
        <span>Ride The Latest Wave</span>
        <span>For A Standout Style</span>
      </>
    ),
    targetPath: '/eyeglasses/brands/niche.html',
    detectProductDetailPath: 'niche',
    logo: `${baseImgUrl}/niche-new/logo.webp`,
    bgPc: `${baseImgUrl}/niche-new/bg-pc.webp`,
    bgSp: `${baseImgUrl}/niche-new/bg-sp.webp`,
    ogImage: `${baseImgUrl}/niche-new/ogp_1200x630.webp`,
    description:
      'Fashion is a mirror of our times and so is eyewear. Constantly evolving to stay abreast of the latest trends while fitting seamlessly into your everyday life, these are the perfect eyewear that can help you find your niche.',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/niche.html`,
  },
  {
    metaTitle: 'OWNDAYS & POMPOMPURIN',
    title: null,
    targetPath: '/eyeglasses/brands/pompompurin.html',
    detectProductDetailPath: 'owndays-pompompurin',
    logo: `${baseImgUrl}/pompompurin/brand_logo.webp`,
    bgPc: `${baseImgUrl}/pompompurin/brand-pc-sg.jpg`,
    bgSp: `${baseImgUrl}/pompompurin/brand-sp-sg.jpg`,
    ogImage: `${baseImgUrl}/pompompurin/ogp_1200x630.webp`,
    description:
      'Presenting the spectacle frame collaboration with POMPOMPURIN. It’s cuteness overload with these spectacle frames featuring Pompompurin, the boy golden retriever with his trademark brown beret. Whether you’re out and about or relaxing at home, pick your favourable pair and keep Pompompurin by your side at all time!',
    keywords:
      'POMPOMPURIN,sanrio,pudding,lineup,collaboration,eyeglasses,sunglasses,snap,Singapore,OWNDAYS',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/pompompurin.html`,
  },
  {
    metaTitle: 'TOM and JERRY × OWNDAYS',
    title: null,
    targetPath: '/eyeglasses/brands/tomandjerry.html',
    detectProductDetailPath: 'tomandjerry',
    logo: `${baseNewImgUrl}/tomandjerry/brand_logo.webp`,
    bgPc: `${baseNewImgUrl}/tomandjerry/brand-pc-sg.webp`,
    bgSp: `${baseNewImgUrl}/tomandjerry/brand-sp-sg.webp`,
    ogImage: `${baseNewImgUrl}/tomandjerry/ogp_1200x630.webp`,
    description:
      'Discover the collection inspired by Tom and Jerry, the beloved slapstick cartoon comedy starring the iconic duo in an endless game of cat-and-mouse! This collaboration captures their playful dynamic - a true friendship wrapped in constant mischief. Packed with hidden surprises, they are sure to leave you smiling.',
    keywords:
      'TOM and JERRY,character,Warner Bros,collaboration,SNAP,eyeglasses,sunglasses,Singapore,OWNDAYS',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/tomandjerry.html`,
  },
  {
    metaTitle: 'OWNDAYS × HUAWEI Eyewear 2',
    title: null,
    targetPath: '/eyeglasses/brands/huawei2.html',
    detectProductDetailPath: 'huawei2',
    logo: `${baseImgUrl2}/huawei2/brand_logo.webp`,
    bgPc: `${baseImgUrl2}/huawei2/brand-pc-sg.webp`,
    bgSp: `${baseImgUrl2}/huawei2/brand-sp-sg.webp`,
    ogImage: `${baseNewOgImgUrl}/huawei2/ogp_1200x630.webp`,
    description:
      'Introducing the Titanium Edition of the OWNDAYS × HUAWEI Eyewear 2 Smart Audio Glasses. With this addition, the collection now features six models, each available in two colour variations. Designed for an enhanced auditory and visual experience, these smart audio glasses offer improved sound quality while weighing lighter than previous generation.',
    keywords:
      'HUAWEI Eyewear2,HUAWEI2,OWNDAYS × HUAWEI Eyewear2,HUAWEI Eyewear,HUAWEI Smart Audio Glasses,HUAWEI sunglasses,SNAP,Collaboration,New Models,glasses,sunglasses,Singapore,2025,OWNDAYS',
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/huawei2.html`,
  },
  {
    metaTitle: "OWNDAYS × FREAK'S STORE",
    title: null,
    targetPath: '/eyeglasses/brands/freaks-store.html',
    detectProductDetailPath: 'freaks-store',
    logo: `${baseImgUrl2}/freaks-store-2025/brand_logo.webp`,
    bgPc: `${baseImgUrl2}/freaks-store-2025/brand-pc.webp`,
    bgSp: `${baseImgUrl2}/freaks-store-2025/brand-sp.webp`,
    ogImage: `${baseImgUrl2}/freaks-store-2025/ogp_1200x630.webp`,
    description:
      'Back by popular demand, our 2nd collection is here! Featuring sunglasses in stylish design with functional lens options such as Transitions and Polarised lenses, this lineup blends functionality with trendiness to suit any scene.',
    keywords: `FREAK'S STORE,life style,collaboration,select store,Japan,photochromic,folding,polarized,sunglasses,eyeframe,eyeglasses,lens,case,cloth,online store,Singapore`,
    isDarkTheme: false,
    canonicalUrl: `${baseCanonicalUrl}/freaks-store.html`,
  },
];
